import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

export const AdsCounterContainer = styled(Typography.Caption).attrs({
  $variant: '1',
})`
  display: inline-block;
  color: ${({ theme }) => theme.palette.quartenary.labels};
  vertical-align: middle;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 14px;
  }
`;

export const AdsCounterSkeletonLoader = styled(SkeletonLoader).attrs({
  borderRadius: 7,
})`
  width: 100px;
  height: 18px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 80px;
    height: 17px;
  }
`;
